import { render } from "./Aside.vue?vue&type=template&id=9bf0490a&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=9bf0490a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9bf0490a"

export default script